import React, { Component } from "react";
import Parameter from "./Parameter";
import { PlusOutlined } from "@ant-design/icons";
import { Button } from "../../../../GeneralComponents/ui";
import i18n from "../../../../../Utils/i18next";

/** What-if parameter list component */
export default class List extends Component {
  render() {
    const { parameters, readOnly, onClickAddParameter } = this.props;

    if (parameters.length === 0) {
      return (
        <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "50%",
          minHeight: "250px",
          backgroundColor: "#fafafa",
          borderRadius: "8px",
          border: "1px solid #f0f0f0"
        }}>
          <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "12px"
          }}>            
            <div style={{ textAlign: "center" }}>
              <h4 style={{ 
                fontSize: 14, 
                fontWeight: 500, 
                color: "#595959", 
                margin: 0 
              }}>
                {i18n.t("Dashboard.Data.WhatIf.NoParameterYetTitle")}
              </h4>
              <p style={{ 
                fontSize: 12, 
                color: "#8c8c8c", 
                margin: "4px 0 16px 0" 
              }}>
                {i18n.t("Dashboard.Data.WhatIf.NoParameterYetMessage")}
              </p>
            </div>

            {readOnly === "WRITE" && (
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={onClickAddParameter}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "4px"
                }}
              >
                {i18n.t("Add")}
              </Button>
            )}
          </div>
        </div>
      );
    }

    return (
      <div className={"whatIf-list"} style={{ width: "100%", flex: 1 }}>
        {parameters.map(parameter => (
          <Parameter
            key={parameter.id}
            readOnly={readOnly}
            setSelectedParameters={this.props.setSelectedParameters}
            removeParameter={this.props.removeParameter}
            updateCurrentValue={this.props.updateCurrentValue}
            parameter={parameter}
            isScreenModeMobile={this.props.isScreenModeMobile}
          />
        ))}
      </div>
    );
  }
}